export { default as AssetModelPage } from './component';
